import Vue from 'vue';
window.Vue = Vue;
import store from '../store';
import {mapState, mapGetters, mapMutations} from 'vuex';
import Quasar from 'quasar';

require('./app');

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

Vue.use(Quasar);

Vue.config.devtools = process.env.MIX_APP_DEBUG;

Vue.component('customer-auth', require('../components/Customer/Auth.vue').default);
Vue.component('customer-account', require('../components/Customer/Account.vue').default);
Vue.component('select-city', require('../components/Modals/City.vue').default);
Vue.component('pickup-points', require('../components/Modals/PickupPoints.vue').default);
Vue.component('subscription', require('../components/Subscription.vue').default);
Vue.component('info-dialog', require('../components/Modals/Info.vue').default);
Vue.component('search', require('../components/Search.vue').default);
Vue.component('confirm-cookies', require('../components/Modals/ConfirmCookies.vue').default);
Vue.component('card', require('../components/Product/Card.vue').default);
Vue.component('product-share', require('../components/Product/Share.vue').default);
Vue.component('product-price', require('../components/Product/Price.vue').default);
Vue.component('product-modal-zoom', require('../components/Product/Zoom.vue').default);
Vue.component('product-favorite', require('../components/Product/Favorite.vue').default);
Vue.component('promo-code', require('../components/Product/PromoCode.vue').default);
Vue.component('add-to-cart-dialog', require('../components/Modals/AddToCart.vue').default);
Vue.component('favorites-dialog', require('../components/Modals/Favorites.vue').default);
Vue.component('comparison-dialog', require('../components/Modals/Comparison.vue').default);
Vue.component('comparison-products', require('../components/Product/ComparisonProducts.vue').default);
Vue.component('comparison-product-carousel', require('../components/Carousel/ComparisonProduct.vue').default);
Vue.component('comparison-card', require('../components/Product/ComparisonCard.vue').default);
Vue.component('one-click-order-dialog', require('../components/Modals/OneClickOrder.vue').default);
Vue.component('product-detail-dialog', require('../components/Modals/ProductDetail.vue').default);
Vue.component('product-size-dialog', require('../components/Modals/ProductSize.vue').default);
Vue.component('remaining-time', require('../components/Product/RemainingTime.vue').default);

// Carousel
Vue.component('product-carousel', require('../components/Carousel/Product.vue').default);
Vue.component('category-carousel', require('../components/Carousel/Category.vue').default);
Vue.component('trend-carousel', require('../components/Carousel/Trend.vue').default);
Vue.component('brand-carousel', require('../components/Carousel/Brand.vue').default);
Vue.component('review-carousel', require('../components/Carousel/Review.vue').default);
Vue.component('product-detail-carousel', require('../components/Carousel/ProductDetail.vue').default);
Vue.component('main-banner-carousel', require('../components/Carousel/MainBanner.vue').default);

window.vm = new Vue({
    el: '#app',
    store,
    comments: true,
    data() {
        return {
            overlay: null,
            workTime: [
                {
                    line: 1,
                    startHour: 3,
                    endHour: 14,
                    days: 'пн-пт',
                },
                {
                    line: 2,
                    startHour: 4,
                    endHour: 13,
                    days: 'сб-вс',
                }
            ],
            toggles: {
                "product-info-description": true,
                "product-info-param": false,
                "product-info-testimonials": false,
                "product-info-questions": false,
                "writeToUs": false,
                "search-open": false,
                "close-search": false,
                "phone-open": false,
                "user-open": false,
                "mobile-menu-open": false,
                "menu-open": false,
                "overlay": false,
            },
            appClasses: [],
        }
    },
    mounted() {
        this.$store.commit('auth/setGender', window.gender || null);
        this.$store.commit('product/setFavoriteProducts', window.favoriteProducts || []);
        this.$store.commit('product/setComparisonProducts', window.comparisonProducts || []);
        this.$store.commit('cart/setItemsCount', window.cartItemsCount || 0);
        this.$store.commit('cart/setCart', window.cart || {});
        this.$store.dispatch('geo/processLocation', window.geoLocation || {});
        this.$store.commit('delivery/setLocation', window.geoLocation || {});
        this.$store.commit('delivery/setPickupPointsCount', parseInt(window.pickupPointsCount) || 0);
        this.$store.commit('delivery/setStoresCount', parseInt(window.storesCount) || 0);
        this.$store.commit('asset/set', window.assets || {});
        this.$store.dispatch('cart/setCustomerData', window.customer || {});
        this.$store.commit('auth/setUser', window.customer || {});

        this.overlay = document.querySelector('#overlay');

        window.assets = undefined;
    },
    destroyed() {
        clearAllBodyScrollLocks();
    },
    methods: {
        ...mapMutations({
            showContactUsModal: 'contactUs/showModal',
            showAuthModal: 'auth/showModal',
            toggleFavoritesModal: 'product/toggleFavoritesModal',
            toggleComparisonModal: 'product/toggleComparisonModal',
            hideDetailModal: 'product/hideDetailModal',
            hideProductSizeModal: 'product/hideProductSizeModal',
            showOneClickOrderModal: 'cart/showOneClickOrderModal',
            showAddToCartModal: 'cart/showAddToCartModal',
            showProductSizeModal: 'product/showProductSizeModal',
            setProduct: 'product/setProduct',
        }),
        redirect(url) {
            window.location.href = url;
        },
        toggle(param) {
            let _this = this;

            for (let key in _this.toggles) {
                if (key === param) {
                    Vue.set(_this.toggles, key, !_this.toggles[key]);
                } else {
                    Vue.set(_this.toggles, key, false);
                }
            }

            _this.appClasses = [];
            if (["search-open", "phone-open", "mobile-menu-open", "user-open"].includes(param) && _this.toggles[param]) {
                _this.appClasses.push(param);
                disableBodyScroll(this.overlay, {
                    allowTouchMove: el => {
                        while (el && el !== document.body) {
                            if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                                return true;
                            }

                            el = el.parentElement;
                        }
                    },
                });
            } else {
                enableBodyScroll(this.overlay);
            }
        },
        toggled(param) {
            return this.toggles[param];
        },
        showPickupPoints(withSelectButton) {
            this.$store.commit('delivery/showPickupPointsModal', !!withSelectButton);
        },
        selectCity() {
            this.$store.commit('geo/showModal');
        },
        setLocation(location) {
            this.$store.dispatch('geo/setLocation', location)
                .then(response => {
                    $('#modal-city').modal('hide');
                });
        },
        addFeedback() {
            if (!this.$store.state.auth.logged) {
                this.$store.commit('auth/stayOnPageAfterAuth');

                this.$store.commit('auth/showModal');
            } else {
                this.$store.commit('feedback/showModal');
            }
        },
        workTimeLine(line) {
            let workTimeLine = this.workTime.find(item => item.line === line);

            let timezone = this.$store.state.geo.location.timezone;

            let additionalHours = timezone ? timezone : 3;

            return workTimeLine.days + ' '
                + (workTimeLine.startHour + additionalHours) + ':00 - '
                + (workTimeLine.endHour + additionalHours) + ':00'
                + (timezone ? '' : ' МСК');
        },
        readCookie(name) {
            let cookieName = name + "=";
            let ca = document.cookie.split(';');

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(cookieName) === 0) return c.substring(cookieName.length, c.length);
            }

            return null;
        },
        account() {
            let cookie = this.readCookie('account');
            if (cookie) {
                try {
                    return JSON.parse(decodeURIComponent(cookie));
                } catch {
                }
            }

            return null;
        },
        priceFormat(x) {
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : x;
        },
        switchFavorites(productId) {
            if (!this.isFavorite(productId) && !this.logged) {
                this.toggleFavoritesModal(true);
            }
            this.$store.dispatch('product/switchFavoriteProduct', {
                productId: productId,
                status: this.isFavorite(productId)
            });
        },
        isFavorite(productId) {
            return _.indexOf(this.favoriteProducts, productId) !== -1;
        },
        switchComparison(productId) {
            if (!this.inComparison(productId)) {
                this.toggleComparisonModal(true);
            }
            this.$store.dispatch('product/switchComparisonProduct', {
                productId: productId,
                status: this.inComparison(productId)
            });
        },
        inComparison(productId) {
            return _.indexOf(this.comparisonProducts, productId) !== -1;
        },
        logout() {
            this.$store.dispatch('auth/logout');
        }
    },
    computed: {
        ...mapState('cart', ['itemsCount']),
        ...mapState('product', ['favoriteProducts', 'comparisonProducts', 'product']),
        ...mapState('auth', ['logged', 'gender']),
        ...mapState('delivery', ['pickupPointsCount']),
        ...mapGetters({
            hasError: 'geo/hasError',
            getError: 'geo/getError',
            cityName: 'geo/cityName',
            hasPickupPoints: 'delivery/hasPickupPoints',
            pickupPointsCountLabel: 'delivery/pickupPointsCountLabel',
            productSizeSelected: 'product/sizeSelected',
            favoriteItemsCount: 'product/favoriteItemsCount',
            comparisonItemsCount: 'product/comparisonItemsCount'
        }),
        region: {
            get() {
                return this.$store.state.geo.form.region.name;
            },
            set(value) {
                this.$store.commit('geo/setRegion', value);
            }
        },
        city: {
            get() {
                return this.$store.state.geo.form.city.name;
            },
            set(value) {
                this.$store.commit('geo/setCity', value);
            }
        },
    },

});

Vue.component('noindex', {
    render(h, {children, props}) {
        const comment1 = h('');
        comment1.text = 'googleoff: all';

        const comment2 = h('');
        comment2.text = 'noindex';

        const comment3 = h('');
        comment3.text = '/noindex';

        const comment4 = h('');
        comment4.text = 'googleon: all';

        return h(props.tag, {
            attrs: { class: props.classes}
        }, [comment1, comment2, ...children, comment3, comment4]);
    },
    functional: true,
    props: {
        tag: {
            type: String,
            default: 'div',
        },
        classes: {
            type: String
        }
    },
})
